export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.config.warnHandler = (msg, _instance, info) => {
    if (shouldIgnore(msg, info)) return;
    console.warn(msg, info);
  };
});

function shouldIgnore(msg: string, info: string) {
  return msg.startsWith('Hydration attribute mismatch')
    && (info.includes('<VField>') || info.includes('<VInput>'));
}